jQuery(function ($) {
    const breakpoint_mobile = 1024;
    let window_width = window.innerWidth;
    let settings = {
        dots: true,
        arrows: false,
    }

    if (window_width < breakpoint_mobile) {
        $(".cursos-grade").slick(settings);
        $(".casperianos-conteudo > .alunos").slick(settings);
        $(".formas-cards").slick(settings);
        $(".cards-voce").slick(settings);
        $(".prepare-literatura > .campos").slick(settings);
    }

    // $(".btn-menu-vest").on("click", function (e) {
    //     e.preventDefault();
    //     $(".menu-mobile-nav").toggle();
    //     if ($(".menu-mobile-nav").is(":visible")) {
    //         $(".vestibulando-conteudo, .header").addClass("menu-ativo");
    //     } else {
    //         $(".vestibulando-conteudo, .header").removeClass("menu-ativo");
    //     }
    // });

    $(".banner-inicial").slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 12000,
        responsive: [
            {
                breakpoint: breakpoint_mobile,
                settings: {
                    arrows: false,
                }
            }
        ]
    });

    $(".casp-controll").on("click", function (e) {
        e.preventDefault();
        let aluno = $(this).data("aluno");
        $(".casp-controll").removeClass("ativo");
        $(this).addClass("ativo");
        $(".alunos").hide();
        if (window_width < breakpoint_mobile) {
            $(`.${aluno}`).css("display", "block");
            $(".casperianos-conteudo > .alunos").slick("unslick");
            $(".casperianos-conteudo > .alunos").slick(settings);
        } else {
            $(`.${aluno}`).css("display", "flex");
        }
    });

    $(".matriz-controll").on("click", function (e) {
        e.preventDefault();
        let curso = $(this).data("curso");
        $(".matriz-controll").removeClass("ativo");
        $(this).addClass("ativo");
        $(".matriz-card").hide();
        $(`.card-${curso}`).css("display", "flex")
    });

    $(".prepare-controll").on("click", function (e) {
        e.preventDefault();
        let campo = $(this).data("campo");
        $(".prepare-controll").removeClass("ativo");
        $(this).addClass("ativo");
        $(".prepare-campo-conteudo").hide();
        $(`.prepare-${campo}`).css("display", "flex");
        if(campo == "literatura" && window_width < breakpoint_mobile){
            $(".prepare-literatura > .campos").slick("unslick");
            $(".prepare-literatura > .campos").slick(settings);
        }
    });

    $(".video-carrossel").slick({
        arrows: true,
        infinite: true,
        centerMode: true,
        adaptiveHeight: true,
        dots: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: breakpoint_mobile,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                }
            }
        ]
    });

    $('.video-carrossel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
       $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
    });

    $(".carrossel-fotos").slick({
        arrows: true,
        infinite: true,
        dots: false,
        slidesToShow: 4,
        centerMode: true,
        centerPadding: "80px",
        responsive: [
            {
                breakpoint: breakpoint_mobile,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                }
            }
        ]
    });

    $(".matriz-link").on("click", function (e) {
        let target = $(this).data("target");
        let colapse = `.colapse-${target}`;

        if ($(colapse).is(":visible")) {
            $(colapse).hide();
            $(this).removeClass("link-ativo");
        } else {
            $(".concentracao-colapse").hide();
            $(colapse).show();
            $(this).addClass("link-ativo");
        }
    });

    $(".perguntas-link").on("click", function (e) {
        let target = $(this).data("target");
        let colapse = `.colapse-${target}`;

        if ($(colapse).is(":visible")) {
            $(colapse).hide();
            $(this).removeClass("link-ativo");
        } else {
            $(".concentracao-colapse").hide();
            $(colapse).show();
            $(this).addClass("link-ativo");
        }
    });
});


// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("myHeader");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
$('.collapse').collapse();